import { __read, __spreadArray } from "tslib";
import { useCallback, useRef } from 'react';
import { CHANNEL_IO_COMMAND_API_NAMES, ChannelIO } from '../ChannelIO';
import { _useContext } from './_useContext';
//
//
//
/**
 * A hook to trigger Channel IO API.
 *
 * @see https://developers.channel.io/docs/web-channelio
 */
export var useChannelIOApi = function () {
    var _return = useRef({});
    var context = _useContext();
    CHANNEL_IO_COMMAND_API_NAMES.forEach(function (name) {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        _return.current[name] = useCallback(function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            ChannelIO.apply(void 0, __spreadArray([name], __read(args), false));
        }, 
        // eslint-disable-next-line react-hooks/exhaustive-deps
        []);
    });
    _return.current.boot = context.boot;
    _return.current.shutdown = context.shutdown;
    return _return.current;
};
